
import inView from 'in-view';

inView('.js-el__inView')
.on('enter', el => {
    el.classList.add('--is-inview')
    el.classList.add('--has-been-inview')
})
.on('exit', el => {
    el.classList.remove('--is-inview')
});